<div class="container-fluid vh-100 d-flex flex-column overflow-hidden px-0">
  <!-- Navbar -->
  <navbar
    @toggle-sidebar="is_sidebar_hidden = !is_sidebar_hidden"
    class="p-2 sticky-top bg-white z-3 border-bottom"
  />

  <!-- Content Area -->
  <div class="row g-0">
    <!-- Sidebar -->
    <div
      :class="[
        'sidebar-col col-md-3 col-lg-2 p-1 flex-column d-none',
        is_sidebar_hidden ? 'd-md-none' : 'd-md-flex'
      ]"
    >
      <div class="flex-grow-1 p-1 mt-2">
        <ProbaWorkflowsSidebar :items="menu_items" @close='is_sidebar_hidden = true' />
      </div>
    </div>

    <!-- Main Content -->
    <div
      :class="[
        'main-content-wrapper transition-all',
        is_sidebar_hidden ? 'col-12 ps-2 pe-3' : 'col-9 col-lg-10 '
      ]"
    >
      <div class="main-content bg-white border-card rounded-lg overflow-auto px-3 py-1 scroll-container mt-3 shadow">
        <router-view></router-view>
      </div>
    </div>
  </div>
</div>
